export const OFFERS_FETCH_ERROR_TOAST_TEXT = 'Что-то пошло не так. Попробуйте ещё раз.';
